import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

export const Redirect: PlatformBlockComponent = ({
  name,
}: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="REDIRECT" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.url`}
            label={t("platformBlocks.redirect.url")}
            type="text"
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
